import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation CreateAsset($companyId: ID!, $attributes: AssetNewAttributes!) {
    createAsset(companyId: $companyId, attributes: $attributes) {
      assets {
        id
        ...CreatedAsset
      }
      errors {
        path
        message
      }
    }
  }

  fragment CreatedAsset on Asset {
    id
    assetType {
      id
    }
  }
`
